<template>
    <span :class="textClass">{{ row.Alacak ||'-' }}</span>
</template>

<script>
export default {
    props:{
        fields:[String,Number],
        row:Object
    },
    computed:{
        textClass(){
            return 'text-success font-weight-bolder'
            
        }
    }
}
</script>